import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import { VersionDetailsService } from "../../../version-details/version.details.service";
import {ProductLabelingState} from "../../../version-details/product.labeling.state";
import {AppConfigService} from "../../../app-config/app-config.service";

@Component({
    selector: 'em-about',
    templateUrl: './about.template.html',
    styleUrls: ['./about.style.css']


})
export class AboutComponent implements OnInit{

    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

    public resources = {
        images: {
            philips: './assets/images/philips.png',
            manufacturerSymbol: './assets/images/manufacture.png',
            manufacturerDateSymbol:  './assets/images/manufacture-date.png',
            consultSymbol: './assets/images/consult.png',
            cautionSymbol: './assets/images/caution.png',
        }
    };

    public productName: string = "Workflow Information Management";
    public commonVersion: string;
    public commercialVersion: string;
    public releaseVersion: string;
    public productCodeNumber: number = 839110;
    public isNonMedicalDevice: boolean;
    public internalVersion: string;
    public isUnreleasedDevice: boolean;
    public buildDate: string;
    public buildDateUDI: string;
    public buildNumber: string;
    public get copyrightMessageHTML(): string {
        return '<strong>© 2025 Koninklijke Philips N.V.</strong> All rights are reserved. Reproduction or transmission in whole or in part, in any form or by any means, electronic, mechanical or otherwise, is prohibited without the prior written consent of the copyright owner.';
    }

    public showUkImporter: boolean = false;

    constructor(private versionDetailsService: VersionDetailsService,private appConfigService: AppConfigService) {
    }


    ngOnInit(): void {
        this.versionDetailsService.getVersionDetails().subscribe(
            versionDetails => {
                const buildDate = new Date(versionDetails.buildDate.toString());
                this.buildDate =   this.getFormattedBuildDate(buildDate);
                this.buildDateUDI = this.getFormattedBuildDateUDI(buildDate);
                this.commonVersion = versionDetails.commercialVersion.split('.')[0];
                this.commercialVersion = versionDetails.commercialVersion;
                this.internalVersion = versionDetails.internalVersion;

                const commercialVersionParts = versionDetails.commercialVersion.split('.');
                this.releaseVersion =  `${commercialVersionParts[0]}.${commercialVersionParts[1]}`;

                const internalVersionParts = versionDetails.internalVersion.split('.');
                this.buildNumber =  internalVersionParts[3];

                this.productName += ` ${this.commonVersion}`;
                if (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice) {
                    this.productName += " (WIP)";
                }

                this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
                this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
                let envPath = this.appConfigService.getBaseURL();
                envPath = envPath.toUpperCase().includes("/ENTERPRISEMANAGERWS") ?
                    envPath.substr(0, envPath.toUpperCase().indexOf("/ENTERPRISEMANAGERWS")) : window.location.origin;
            }
          )
    }

    private getFormattedBuildDate(buildDate: Date): string {
        return buildDate.getFullYear() + "-"
            +  this.padDatePart(buildDate.getMonth() + 1) + "-"
            + this.padDatePart(buildDate.getDate());
    }

    private getFormattedBuildDateUDI(buildDate: Date): string {
        const year = buildDate.getFullYear().toString().substr(2);
        const month = this.padDatePart(buildDate.getMonth() + 1);
        const day = this.padDatePart(buildDate.getDate());

        return year + month + day;
    }

    private padDatePart(datePart: number) {

        const datePartStr = datePart.toString();
        if (datePartStr.length === 1){
            return "0" + datePartStr;
        }
        return datePartStr;
    }

}
